export const getErrorForPath = (errors: unknown, path: string): string | undefined => {
  const extractErrorText = (value: any): string | undefined => {
    if (!value) {
      return undefined;
    }

    if (typeof value === "string") {
      return value;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        const itemMessage = extractErrorText(item);
        if (itemMessage) {
          return itemMessage;
        }
      }
      return undefined;
    }

    if (typeof value === "object") {
      if (typeof value.message === "string") {
        return value.message;
      }

      if (Array.isArray(value.errors)) {
        const arrayMessage = extractErrorText(value.errors);
        if (arrayMessage) {
          return arrayMessage;
        }
      }

      for (const key of Object.keys(value)) {
        const nestedMessage = extractErrorText((value as any)[key]);
        if (nestedMessage) {
          return nestedMessage;
        }
      }
    }

    return undefined;
  };

  const normalizePath = (input: string) =>
    input
      .replace(/([A-Za-z_]+)(\d+)/g, "$1.$2") // convert modules0 -> modules.0
      .replace(/\[(\w+)\]/g, ".$1") // convert indexes to properties
      .replace(/^\./, ""); // strip a leading dot

  const normalizedPath = normalizePath(path);
  const pathKeys = normalizedPath.split(".");

  let nestedResult = errors as any;
  for (let i = 0; i < pathKeys.length; ++i) {
    const key = pathKeys[i];
    const nextKey = pathKeys[i + 1];

    if (nestedResult && typeof nestedResult === "object" && Object.prototype.hasOwnProperty.call(nestedResult, key)) {
      nestedResult = nestedResult[key] as any;
      continue;
    }

    // Support "compact" keys produced by our validation error object:
    // e.g. competences0, modules1, learningSets0
    const hasCompactArrayKey = /^\d+$/.test(nextKey ?? "");
    const compactArrayKey = hasCompactArrayKey ? `${key}${nextKey}` : undefined;

    if (
      compactArrayKey &&
      nestedResult &&
      typeof nestedResult === "object" &&
      Object.prototype.hasOwnProperty.call(nestedResult, compactArrayKey)
    ) {
      nestedResult = nestedResult[compactArrayKey] as any;
      i++;
      continue;
    }

    nestedResult = undefined;
    break;
  }

  const nestedMessage = extractErrorText(nestedResult);
  if (nestedMessage) {
    return nestedMessage;
  }

  // Some validators can also store errors by path string keys.
  const bracketPath = normalizedPath.replace(/\.(\d+)(?=\.|$)/g, "[$1]");
  const compactPath = pathKeys
    .reduce((acc: string[], key) => {
      if (/^\d+$/.test(key) && acc.length > 0) {
        acc[acc.length - 1] = `${acc[acc.length - 1]}${key}`;
      } else {
        acc.push(key);
      }
      return acc;
    }, [])
    .join(".");

  const directCandidates = [path, normalizedPath, bracketPath, compactPath];
  for (const candidate of directCandidates) {
    if (!candidate) {
      continue;
    }
    const directMessage = extractErrorText((errors as any)?.[candidate]);
    if (directMessage) {
      return directMessage;
    }
  }

  return undefined;
};

